import { Component, inject } from '@angular/core';
import { MatDialogRef, MatDialogTitle, MatDialogClose, MatDialogContent } from '@angular/material/dialog';
import { CdkScrollable } from '@angular/cdk/scrolling';

@Component({
  selector: 'app-payment',
  standalone: true,
  templateUrl: './payment.component.html',
  styleUrls: ['./payment.component.scss'],
  imports: [MatDialogTitle, MatDialogClose, CdkScrollable, MatDialogContent],
})
export class PaymentComponent {
  private dialogRef = inject<MatDialogRef<PaymentComponent>>(MatDialogRef);

  closeDialog() {
    this.dialogRef.close(); // Close the dialog when the close button is clicked
  }
}
